import React, { useState } from 'react';
import Remarkable from 'react-remarkable';
import { useDispatch, useSelector } from 'react-redux';
import { Description } from './QuestConfirmationCSS';
import {
  ModalContent,
  Title,
  OptionsList,
  OptionItem,
  OptionButton,
  SendButton,
} from './QuestMultipleChoiceCSS';

const QuestMultipleChoice = () => {
  const dispatch = useDispatch();
  const currentInteraction = useSelector(
    (state) => state.interaction.currentInteraction
  );

  // Guard clause: Only render for questMultChoice interactions
  if (!currentInteraction || currentInteraction.type !== 'questMultChoice')
    return null;

  const { question, options, questionId, description } =
    currentInteraction.data;

  // State for selected options
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Function to toggle option selection
  const toggleOption = (option) => {
    setSelectedOptions(
      (prevSelected) =>
        prevSelected.includes(option)
          ? prevSelected.filter((item) => item !== option) // Deselect
          : [...prevSelected, option] // Select
    );
  };

  // Dispatch the selected options
  const handleSend = () => {
    if (selectedOptions.length > 0) {
      dispatch({
        type: 'INTERACTION_RESPONSE',
        payload: {
          questionId,
          response: JSON.stringify(selectedOptions),
          isAlternative: false,
        },
      });
    } else {
      alert('Please select at least one option before sending.');
    }
  };

  return (
    <ModalContent>
      <Title>{question}</Title>
      <Description>
        <Remarkable source={description ?? ''} />
      </Description>

      {/* Multiple choice options - horizontal layout */}
      <OptionsList>
        {options.map((option, index) => (
          <OptionItem key={index}>
            <OptionButton
              isSelected={selectedOptions.includes(option)}
              onClick={() => toggleOption(option)}
            >
              {option}
            </OptionButton>
          </OptionItem>
        ))}
      </OptionsList>

      <SendButton onClick={handleSend} disabled={selectedOptions.length === 0}>
        Send
      </SendButton>
    </ModalContent>
  );
};

export default QuestMultipleChoice;
